'use client';

import { useRef } from 'react';
import {
  HeroSection,
  FeaturesSection,
  ServiceCategoriesSection,
  HowItWorksSection,
  UserPersonasSection,
  AudienceTeasersSection,
  ClosingSection,
} from './landing/sections';

/**
 * @group Public
 * @summary Landing page component
 * 
 * Main landing page for the Phila website, displaying all marketing
 * sections for the telemedicine platform.
 */
export function LandingPage() {
  // Create ref for smooth scrolling to "How It Works" section
  const howItWorksRef = useRef<HTMLElement>(null);

  const scrollToHowItWorks = () => {
    howItWorksRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <main className="min-h-screen">
      {/* Hero - Main headline and CTAs */}
      <HeroSection onScrollToHowItWorks={scrollToHowItWorks} />

      {/* Features - Access, Speed - INDENTED */}
      <FeaturesSection />
      
      {/* How It Works - 3-step journey - POKING OUT */}
      <HowItWorksSection ref={howItWorksRef} />
      
      {/* Service Categories - 8 healthcare services - INDENTED */}
      <ServiceCategoriesSection />

      {/* User Personas - Target audience segments - INDENTED */}
      <UserPersonasSection />

      {/* Audience Teasers - Links to Employers & Doctors pages - INDENTED */}
      <AudienceTeasersSection />
      
      {/* Closing - Final CTA and tagline - POKING OUT */}
      <ClosingSection />
    </main>
  );
}
